import axios from 'axios';
import {API_BASE_URL,API_ROUTES } from '../constants/constant';


const api = axios.create({
    baseURL: API_BASE_URL,
})

api.defaults.headers.post['Content-Type'] = 'application/json';
api.defaults.headers.post['Accept'] = 'application/json';
// api.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
// api.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
// api.defaults.headers.post['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Requested-With, Accept';

api.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
    return config;
}, function (error) {
    return Promise.reject(error);
});

api.interceptors.response.use((response)=>{
    return response;
}, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        // originalRequest._retry = true;
        // const refreshToken = localStorage.getItem('refreshToken');
        // const res = await axios.post(API_ROUTES.REFRESH_TOKEN,{token: refreshToken});
        // if(res.status === 200){
        //     localStorage.setItem('accessToken', res.data.accessToken);
        //     api.defaults.headers.common['Authorization'] = `Bearer ${res.data.accessToken}`;
        //     return api(originalRequest);
        // }
        
        ////return api.post('/auth/refresh-token', { refreshToken })
    }
    return Promise.reject(error);
});




export default api
